// dependencies
import React from "react";
import { z } from "zod";

// components
import { FormCheckboxGroup, PanelFilters } from "@performyard/py-components";

export const CycleTypeSelectionOptions = [
	{ label: "Manual Review Cycles", value: "manual" },
	{ label: "Automated Review Cycles", value: "automated" },
	{ label: "Group Review Cycles", value: "group" },
];

export const StatusSelectionOptions = [
	{ label: "Active", value: "active" },
	{ label: "Scheduled", value: "scheduled" },
	{ label: "Completed", value: "completed" },
];

const Reviews360Options = [{ label: "360 Review Enabled", value: "easyAddEnabled" }];

export const ReviewCycleRefreshFilterSchema = z.object({
	type: z.array(z.enum(["manual", "automated", "group"])).optional(),
	status: z.array(z.enum(["active", "scheduled", "completed"])).optional(),
	reviews360: z.array(z.string()).optional(),
});

export type ReviewCycleRefreshFilter = z.infer<typeof ReviewCycleRefreshFilterSchema>;

type ReviewCyclesFiltersRefreshProps = {
	isOpen: boolean;
	onClose: () => void;
	filters: ReviewCycleRefreshFilter;
	onApplyFilters: (filters: ReviewCycleRefreshFilter) => void;
};

/** Multi-select filter panel for the refreshed Review Cycles table. */
const ReviewCyclesFiltersRefresh = ({ isOpen, onClose, filters, onApplyFilters }: ReviewCyclesFiltersRefreshProps) => {
	const defaultValues: ReviewCycleRefreshFilter = {
		type: filters?.type || [],
		status: filters?.status || [],
		reviews360: filters?.reviews360 || [],
	};

	const handleApplyFilters = ({ value }: { value: Partial<ReviewCycleRefreshFilter> }) => {
		const formattedState = { ...value };
		Object.keys(formattedState).forEach((key) => {
			const filterValue = formattedState[key as keyof ReviewCycleRefreshFilter];
			if (filterValue === null || filterValue === undefined || filterValue.length === 0) {
				delete formattedState[key as keyof ReviewCycleRefreshFilter];
			}
		});

		onApplyFilters(formattedState);
		onClose();
	};

	return (
		<PanelFilters
			isOpen={isOpen}
			onClose={onClose}
			schema={ReviewCycleRefreshFilterSchema}
			defaultValues={defaultValues}
			onSubmit={handleApplyFilters}
		>
			<div className="space-y-4">
				<FormCheckboxGroup id="type" label="Review Cycle Type" options={CycleTypeSelectionOptions} />
				<FormCheckboxGroup id="status" label="Status" options={StatusSelectionOptions} />
				<FormCheckboxGroup id="reviews360" label="360 Reviews" options={Reviews360Options} />
			</div>
		</PanelFilters>
	);
};

export default ReviewCyclesFiltersRefresh;
